import React, { useState, useEffect } from "react";
import "react-simple-keyboard/build/css/index.css";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { ApiKey, ApiUrl } from "../../util/Constant";
import ApiEngine from "../../util/ApiEngine";
import { stringIsNullOrEmpty, numberWithCurrencyFormat } from "../../util/Util";
import DynamicLoadTable from "../../components/custom/DynamicLoadTable";
import ContentHeader from "components/content/header";
import DateRangeFilter from "../../components/custom/DateRangeFilter";

const Registers = (props) => {
  const { t } = useTranslation();
  const [registersUrl, setRegistersUrl] = useState("");
  const [registersData, setRegistersData] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [startDate, setStartDate] = useState(moment().startOf("week").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().endOf("week").format("YYYY-MM-DD"));

  useEffect(() => {
    getRegistersData(startDate, endDate);
  }, []);

  async function getRegistersData(start, end, selected = "") {
    var apiUrl =
      ApiUrl._API_GET_NEW_MEMBERS_LIST +
      "?StartDate=" +
      moment(start).format("YYYY-MM-DD") +
      "&EndDate=" +
      moment(end).format("YYYY-MM-DD") +
      "&v=" +
      Date.now();

    if (!stringIsNullOrEmpty(selected)) {
      apiUrl += "&SelectedDate=" + moment(selected).format("YYYY-MM-DD");
    }
    setRegistersUrl(apiUrl);
  }

  useEffect(() => {
    if (!stringIsNullOrEmpty(selectedDate)) {
      getRegistersData(startDate, endDate, selectedDate);
    }
  }, [selectedDate]);

  function getRecordFromDynamicLoad(data) {
    setRegistersData(data);
  }

  return (
    <>
      <section className="section-padding" id="registers-report-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ContentHeader enableBackButton title={t("NEW_MEMBER_LIST_IN_7_DAYS")} />
              <hr className="right-title-hr" />
              <div className="template-box mt-3" id="registers-report-box">
                <DateRangeFilter
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  onSave={(start, end) => {
                    setStartDate(moment(start));
                    setEndDate(moment(end));
                    getRegistersData(start, end);
                    setSelectedDate("");
                  }}
                  options={true}
                />
                <div className="card card-package">
                  <div className="card-body p-0" style={{ overflowX: "auto" }}>
                    <table className="table reportTable">
                      <thead>
                        <tr>
                          <th>{t("USERNAME")}</th>
                          <th>{t("FULLNAME")}</th>
                          <th>{t("UPLINE")}</th>
                          <th>{t("EMAIL")}</th>
                          <th>{t("PHONE")}</th>
                          <th>{t("CREATED_TIME")}</th>
                          <th style={{ textAlign: 'right' }}>{t("DEPOSITED")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <DynamicLoadTable
                          returnRecord={getRecordFromDynamicLoad}
                          pageSize={20}
                          apiQuery={registersUrl}
                          isTable={true}
                          searchEnabled={true}
                          render={(item, i) => {
                            const displayDate = item.createdTime 
                              ? moment(item.createdTime).format("YYYY-MM-DD HH:mm:ss")
                              : "-";
                            
                            return (
                              <tr key={"registers_report_" + i}>
                                <td>{item.username || "-"}</td>
                                <td>{item.fullname || "-"}</td>
                                <td>{item.upline || "-"}</td>
                                <td>{item.email || "-"}</td>
                                <td>{item.phone || "-"}</td>
                                <td>{displayDate}</td>
                                <td style={{ textAlign: 'right' }}>
                                  {item.deposited ? t("YES") : t("NO")}
                                </td>
                              </tr>
                            );
                          }}
                        />
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="6">
                            <b>{t("TOTAL_REGISTRATIONS")}</b>
                          </td>
                          <td style={{ textAlign: 'right' }}>
                            <b>
                              {registersData.length}
                            </b>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Registers;
